<template>
  <v-container fluid>
    <PageHeading
      :text="'Рекламные места'"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-ad-placement-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Создать рекламное место
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridAdPlacements ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridAdPlacements from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageAdPlacements',
  components: {
    PageHeading,
    GridAdPlacements
  },
  metaInfo () {
    return {
      title: 'Посты блога'
    }
  },
  mixins: [gridPageInterface]
}
</script>
